(() => {
  const widgetSelector = '#judgeme_product_reviews';
  const openTriggerSelector = '[data-hoo-open-review-form]';
  const officialButtonSelector = '.jdgm-write-rev-link';
  const formSelectors = ['.jdgm-form-wrapper', '.jdgm-form-dynamic-wrapper'];

  const isVisible = (element) => {
    if (!element) return false;
    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.height > 0;
  };

  const focusForm = (widget) => {
    const field = widget.querySelector(
      '.jdgm-form-wrapper input:not([type="hidden"]), .jdgm-form-wrapper textarea, .jdgm-form-dynamic-wrapper input:not([type="hidden"]), .jdgm-form-dynamic-wrapper textarea'
    );

    if (field) field.focus({ preventScroll: true });
  };

  const finishOpening = (widget, officialButton) => {
    const formIsVisible = formSelectors.some((selector) => isVisible(widget.querySelector(selector)));

    if (!formIsVisible) {
      widget.classList.add('hoo-review-form-open');
    }

    if (officialButton) {
      officialButton.setAttribute('aria-expanded', 'true');
    }

    window.setTimeout(() => {
      const visibleForm = formSelectors.map((selector) => widget.querySelector(selector)).find(isVisible);
      (visibleForm || widget).scrollIntoView({ behavior: 'smooth', block: 'start' });
      focusForm(widget);
    }, 60);
  };

  const openReviewForm = (widget) => {
    const officialButton = widget.querySelector(officialButtonSelector);
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (officialButton && officialButton.getAttribute('aria-expanded') !== 'true') {
      officialButton.click();
    }

    window.setTimeout(() => finishOpening(widget, officialButton), 450);
  };

  const openWhenReady = () => {
    const existingWidget = document.querySelector(widgetSelector);
    if (existingWidget) {
      openReviewForm(existingWidget);
      return;
    }

    const observer = new MutationObserver(() => {
      const widget = document.querySelector(widgetSelector);
      if (!widget) return;

      observer.disconnect();
      openReviewForm(widget);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const cancelButton = target.closest(`${widgetSelector} .jdgm-cancel-rev`);
    if (cancelButton) {
      const widget = cancelButton.closest(widgetSelector);
      widget?.classList.remove('hoo-review-form-open');
      widget?.querySelector(officialButtonSelector)?.setAttribute('aria-expanded', 'false');
      return;
    }

    const officialButton = target.closest(`${widgetSelector} ${officialButtonSelector}`);
    if (officialButton) {
      const widget = officialButton.closest(widgetSelector);
      if (widget) window.setTimeout(() => finishOpening(widget, officialButton), 450);
      return;
    }

    const trigger = target.closest(openTriggerSelector);
    if (!trigger) return;

    event.preventDefault();
    openWhenReady();
  });

  const query = new URLSearchParams(window.location.search);
  if (query.get('write_review') === '1' && window.location.hash === widgetSelector) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openWhenReady, { once: true });
    } else {
      openWhenReady();
    }
  }
})();
